import {
  LocalizationProvider,
  TimeField,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import React, { FunctionComponent } from "react";
import { ITimePickerProps } from "./ITimePickers";

const TimePickers: FunctionComponent<ITimePickerProps> = (props) => {
  const {
    ampm,
    label,
    ampmInClock,
    autoFocus,
    closeOnSelect,
    desktopModeMediaQuery,
    disabled,
    disableFuture,
    disableIgnoringDatePartForTimeValidation,
    disableOpenPicker,
    disablePast,
    format,
    formatDensity,
    inputRef,
    maxTime,
    minTime,
    localeText,
    minutesStep,
    className,
    onChange,
    onAccept,
    onClose,
    onError,
    onOpen,
    onSelectedSectionsChange,
    onViewChange,
    open,
    openTo,
    orientation,
    referenceDate,
    selectedSections,
    shouldDisableTime,
    skipDisabled,
    slotProps,
    slots,
    sx,
    timeSteps,
    thresholdToRenderTimeInASingleColumn,
    timezone,
    value,
    view,
    // viewRenderers,
    views,
  } = props;
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["TimePicker"]}>
        <TimePicker
          ampm={ampm}
          label={label}
          ampmInClock={ampmInClock}
          closeOnSelect={closeOnSelect}
          autoFocus={autoFocus}
          desktopModeMediaQuery={desktopModeMediaQuery}
          disabled={disabled}
          disableFuture={disableFuture}
          disableIgnoringDatePartForTimeValidation={
            disableIgnoringDatePartForTimeValidation
          }
          disableOpenPicker={disableOpenPicker}
          disablePast={disablePast}
          format={format}
          formatDensity={formatDensity}
          inputRef={inputRef}
          localeText={localeText}
          maxTime={maxTime}
          minTime={minTime}
          minutesStep={minutesStep}
          className={className}
          onAccept={onAccept}
          onChange={onChange}
          onClose={onClose}
          onError={onError}
          onOpen={onOpen}
          onSelectedSectionsChange={onSelectedSectionsChange}
          onViewChange={onViewChange}
          open={open}
          openTo={openTo}
          orientation={orientation}
          referenceDate={referenceDate}
          selectedSections={selectedSections}
          shouldDisableTime={shouldDisableTime}
          skipDisabled={skipDisabled}
          slotProps={slotProps}
          slots={slots}
          sx={sx}
          thresholdToRenderTimeInASingleColumn={
            thresholdToRenderTimeInASingleColumn
          }
          timeSteps={timeSteps}
          timezone={timezone}
          value={value}
          view={view}
          // viewRenderers={viewRenderers}
          views={views}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};

export default TimePickers;
